<h2 mat-dialog-title>Rename Main Domain</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="New Main Domain"
      formControlName="newDomain"
      type="text"
      [errorMessages]="errors['domain']"
    ></app-input-field>

    <div class="checkboxes">
      <mat-checkbox formControlName="dns">Keep existing DNS records</mat-checkbox>
      <span class="checkbox-hint"
        >The current DNS zone and records will be transferred to the new domain. If unchecked, a new
        default DNS zone will be created.</span
      >
      <mat-checkbox formControlName="email">Keep existing mailboxes</mat-checkbox>
      <span class="checkbox-hint"
        >Move all mailboxes and their contents to the new domain. If unchecked, all mailboxes will
        be deleted.</span
      >
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Save changes</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
